// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications {
  position: relative;
}

ion-progress-bar {
  position: fixed;
  z-index: 99999;
}

ion-buttons {
  margin-right: 12px;
}
ion-buttons[slot=primary] ion-button {
  margin-left: 6px;
}
ion-buttons[slot=primary] ion-button.notifications {
  font-size: 20px;
}
ion-buttons ion-button#mc-popover {
  background-color: var(--ion-color-lighter-light-lighter);
  border-radius: 100%;
  text-align: center;
  font-size: 14px;
  width: 32px;
  height: 32px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/header/header.component.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;AACD;;AAEA;EACC,eAAA;EACA,cAAA;AACD;;AAMA;EACC,kBAAA;AAHD;AAKE;EACC,gBAAA;AAHH;AAIG;EACC,eAAA;AAFJ;AAQE;EACC,wDAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AANH","sourcesContent":[".notifications {\r\n\tposition: relative;\r\n}\r\n\r\nion-progress-bar {\r\n\tposition: fixed;\r\n\tz-index: 99999;\r\n}\r\n\r\nion-header ion-toolbar {\r\n\t// --ion-toolbar-background: var(--ion-color-primary-contrast);\r\n}\r\n\r\nion-buttons {\r\n\tmargin-right: 12px;\r\n\t&[slot=\"primary\"] {\r\n\t\tion-button {\r\n\t\t\tmargin-left: 6px;\r\n\t\t\t&.notifications {\r\n\t\t\t\tfont-size: 20px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\tion-button {\r\n\t\t&#mc-popover {\r\n\t\t\tbackground-color: var(--ion-color-lighter-light-lighter);\r\n\t\t\tborder-radius: 100%;\r\n\t\t\ttext-align: center;\r\n\t\t\tfont-size: 14px;\r\n\t\t\twidth: 32px;\r\n\t\t\theight: 32px;\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
